import styled, { type DefaultTheme, type ThemeProps } from 'styled-components'

interface ISubtotalIndicatorStyledProps extends ThemeProps<DefaultTheme> {
  indicatorColor: string
  indicatorStriped?: boolean
}

export const SubtotalIndicatorStyled =
  styled.div<ISubtotalIndicatorStyledProps>(
    (props) => `
      border-radius: 50%;
      height: ${props.theme.typography.pxToRem(12)};
      width: ${props.theme.typography.pxToRem(12)};
      background-color: ${props.theme.colors[props.indicatorColor]};
      border: 1px solid ${props.theme.colors[props.indicatorColor]};

      ${
        props.indicatorStriped &&
        `
          background-image: repeating-linear-gradient(
            45deg,
            transparent,
            transparent 1px,
            ${props.theme.colors.white} 3px,
            ${props.theme.colors.white} 4px
          );
      `
      }
    `
  )
